import { z } from 'zod';
/**
 * What a signed upload is FOR. The backend's own copy is the `kind` enum in
 * `api/routes/uploads/index.ts`, and the two are pinned to each other — and to
 * the behaviour behind each of them — in `backend/tests/contracts.test.ts`.
 *
 * `email_asset` was added to the backend and never here, so this list has been
 * one kind short since email templates shipped: a console validating a request
 * against it would have refused an upload the server accepts. `brand_image` is
 * the printed card's own kind. Both are added together because the pin below
 * asserts the two lists are IDENTICAL, and a pin that only checks the key you
 * just added is a pin that lets the next one drift.
 */
export const UploadKindSchema = z.enum([
    'profile',
    'sponsor_logo',
    'speaker',
    'photo',
    'theme_logo',
    'theme_splash',
    'event_cover',
    'email_asset',
    'brand_image',
]);
export const SignUploadRequestSchema = z.object({
    kind: UploadKindSchema,
    contentType: z.string().min(1).max(120),
    eventId: z.string().uuid(),
    sponsorId: z.string().uuid().optional(),
    speakerId: z.string().uuid().optional(),
});
export const SignUploadResponseSchema = z.object({
    data: z.object({
        url: z.string().url(),
        storagePath: z.string(),
        expiresAt: z.string(),
        maxBytes: z.number().int().positive(),
    }),
});
//# sourceMappingURL=uploads.js.map